export default function Footer() {
    return (
        <footer className="bg-secondary">
            <div className="container">
                <p className="text-center text-light my-3"><a target="_blank" href="https://www.ourjourney.uk/" className="text-white">Our Journey</a>, developed by <a target="_blank" className="text-white"href="https://ociusconsulting.co.uk/">Ocius Consulting</a>. Application developed by <a className="text-light" href="https://www.webhq.uk" target="_blank" rel="noopener noreferrer">WebHQ.</a></p>
            </div>
        </footer>
    )
}
